<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">应急任务管理&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>应急点位管理</div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="biaodan2">
        <div class="biaodan-left">
          <div style="height: 100%;width: 100%;">
            <el-form
              :inline="true"
              label-position="left"
              class="demo-form-inline"
              :model="form"
            >
              <el-form-item label="点位名称">
                <el-input
                  v-model="form.pointName"
                  clearable
                  placeholder="请输入点位名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="所属社区">
                <el-select
                  filterable
                  placeholder="所属社区"
                  clearable
                  v-model="communityCode"
                  @change="commcommunityChange"
                >
                  <el-option
                    v-for="item in commcommunityList"
                    :key="item.deptCode"
                    :label="item.pointName"
                    :value="item.id + '-' + item.deptCode"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属网格">
                <el-select
                  filterable
                  placeholder="所属网格"
                  clearable
                  v-model="form.jqDeptCode"
                >
                  <el-option
                    v-for="item in blockList"
                    :key="item.deptCode"
                    :label="item.pointName"
                    :value="item.deptCode"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form-item">
                <el-button @click="onSearch" class="search">查询</el-button>
                <el-button class="reset" @click="onReset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="aside">
        <div class="table-top-btns">
          <div class="left-btn"></div>
          <div class="right-btn">
            <el-button @click="addDialogFun({})" class="search el-icon-plus"
              >添加</el-button
            >
          </div>
        </div>
        <common-table
          :select="false"
          :page="page"
          :dataList="dataList"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        >
          <template v-slot:operation="{ scope }">
            <el-button
              @click="levelInfoDialogFun(scope.row)"
              style="color: #0090FF;font-size: 16px;"
              type="text"
              >避难场所等级信息管理</el-button
            >
            <el-button
              @click="delPointTypeFun(scope.row.id)"
              style="color: #EB3538;font-size: 16px;"
              type="text"
              >删除</el-button
            >
          </template>
        </common-table>
      </div>
    </div>
    <addDialog
      v-if="dialogVisible"
      @refreshList="pageListFun"
      :dialogVisible.sync="dialogVisible"
      :curItem="curItem"
    >
    </addDialog>
    <levelInfoDialog
      v-if="levelInfoVisible"
      @refreshList="pageListFun"
      :dialogVisible.sync="levelInfoVisible"
      :curItem="curItem"
    >
    </levelInfoDialog>
  </div>
</template>
<script>
import { pageList, delEmergency } from "@/api/crashInfo.js";
import addDialog from "./components/addDialog.vue";
import levelInfoDialog from "./components/levelInfoDialog.vue";
import commonTable from "@/components/table/index.vue";
import index from "@/mixins/index.js";
export default {
  components: {
    addDialog,
    commonTable,
    levelInfoDialog
  },
  mixins: [index],
  data() {
    return {
      form: {
        pointName: "",
        jqDeptCode: "",
        communityCode: ""
      },
      dialogVisible: false,
      levelInfoVisible: false,
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "pointNameTypes",
            label: "点位类型"
          },
          {
            prop: "pointName",
            label: "点位名称"
          },
          {
            prop: "sq",
            label: "所属社区"
          },
          {
            prop: "jq",
            label: "所属网格"
          },
          {
            slot: "operation",
            label: "操作",
            width: 240
          }
        ]
      },
      curItem: {}
    };
  },
  mounted() {
    this.getCommcommunityAllFun();
    this.pageListFun();
  },
  methods: {
    addDialogFun(item) {
      this.dialogVisible = true;
      this.curItem = item;
    },
    levelInfoDialogFun(item) {
      this.levelInfoVisible = true;
      this.curItem = item;
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.pageListFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.pageListFun();
    },

    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.pageListFun();
    },
    onReset() {
      this.communityCode = "";
      this.form.pointName = "";
      this.form.jqDeptCode = "";
      this.form.communityCode = "";
      this.page.page = 1;
      this.page.size = 10;
      this.pageListFun();
    },
    // 删除
    async delPointTypeFun(id) {
      let params = {
        id: id
      };
      const res = await delEmergency(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.onSearch();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    // 分页查询
    async pageListFun() {
      let params = {
        pointName: this.form.pointName,
        jqDeptCode: this.form.jqDeptCode,
        sqDeptCode: this.form.communityCode,
        page: this.page.page,
        size: this.page.size
      };
      const res = await pageList(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.page.total = res.data.data.total;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/crashInfo/crashPoint/index.vue